import React, { useEffect, useRef } from 'react';
import { LoadingDots } from '../../ui';
import { useNavigate } from "react-router-dom";
import { useLogout } from '../auth/hooks/useAuthActions';

const logoutMessages = [
  "Catch ya later—time to blast you back to the login screen!",
  "Whoops, your session's expired—sayonara, time to log out!",
  "We're kicking you out with love—back to the login lounge you go!",
  "Your VIP pass has expired—poof, you're logged out, superstar!",
  "Time's up! We're sending you to the logout dimension—zap!",
]

const Logout = () => {
  const navigate = useNavigate();
  const called = useRef(false);
  const logout = useLogout();

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    // Provider handles storage clearing and navigation
    logout().finally(() => {
      navigate('/login', { replace: true });
    });
  }, [logout, navigate]);

  const randomMessage = logoutMessages[Math.floor(Math.random() * logoutMessages.length)];
  return <LoadingDots message={randomMessage} fullContainer={true}/>;
}

export default Logout;
